/* 
    *  You have to include the store in each modal because  
    *  ionic decided they didn't need to access it. This 
    *  also won't show up in your Vue Debugger.
*/

import axios from 'axios';

import { Plugins } from '@capacitor/core';

const { Modals } = Plugins;

import './styles.scss';
import store from '../../store';
import { BASE_URL } from '@/constants/constants';

const CheckboxGroup = () => import('../../components/checkbox-group/index.vue');
const rootUrl = BASE_URL;

export default {
    name: 'ShareDocumentModal',
    store,
    components: {
        'checkbox-group': CheckboxGroup
    },

    props: {
        'annotations': Object,
        'document': Object
    },

    data() {
        return {
            
            roles: [],
            groups: [],
            users: [],
            
            available_roles: [],
            available_groups: [],
            available_users: [],

        };
    },

    computed: {
        canSubmit() {
            return this.roles.length > 0 || this.groups.length > 0 || this.users.length > 0;
        },
        building() {
            return this.$store.getters.getActiveBuilding;
        },
        rolesSelected() {
            if ( this.roles.length === 0 ) { return 'Select roles to share with'; }
            if ( this.roles.includes('0') ) { return 'All Roles'; }
            if ( this.roles.length === this.available_roles.length - 1 ) { return 'All Roles'; }
            let textString = [];
            for ( const index in this.available_roles ) {
                const item =  this.available_roles[index];
                if ( this.roles.includes(String(item.id)) ) {
                    textString.push(item.name);
                }
                return textString.join(',');
            }
        },
        groupsSelected() {
            if ( this.groups.length === 0 ) { return 'Select groups to share with'; }
            if ( this.groups.includes('0') ) { return 'All Groups'; }
            if ( this.groups.length === this.available_groups.length - 1 ) { return 'All Groups'; }
            let textString = [];
            for ( const index in this.available_groups ) {
                const item =  this.available_groups[index];
                if ( this.groups.includes(String(item.id)) ) {
                    textString.push(item.name);
                }
                return textString.join(',');
            }
        },
        usersSelected() {
            if ( this.users.length === 0 ) { return 'Select users to share with'; }
            if ( this.users.includes('0') ) { return 'All Users'; }
            if ( this.users.length === this.available_users.length - 1 ) { return 'All Users'; }
            let textString = [];
            for ( const index in this.available_users ) {
                const item =  this.available_users[index];
                if ( this.users.includes(String(item.id)) ) {
                    textString.push(item.name);
                }
                return textString.join(',');
            }
        },
        allRoles() {
            return true;
        },
        allGroups() {
            return true;
        },
        allUsers() {
            return true;
        }
    },

    watch: {

        building(newValue, oldValue) {
            
            const roles = this.building.roles;
            roles.unshift({ id: 0, name: 'All Roles' });
            this.available_roles = roles;
            
            const groups = this.building.groups;
            groups.unshift({ id: 0, name: 'All Groups' });
            this.available_groups = groups;

            const users = this.building.users;
            users.unshift({ id: 0, name: 'All Users' });
            this.available_users = users;
        }
    
    },

    methods: {

        compareWith(newValue, oldValue) {
            return true;
        },

        dismissModal() {
            this.$ionic.modalController.dismiss();
        },
 
        updateRoles(event) {
            this.roles = event.detail.value;
            if ( this.roles.includes("0") ) {
                const new_roles = [];
                for ( const index in this.available_roles ) {
                    const item = this.available_roles[index];
                    if ( String(item.id) !== '0' && item.id !== 0 ) {
                        new_roles.push(String(item.id));
                    }
                }
                this.roles = new_roles;
            }
        },

        updateGroups(event) {
            this.groups = event.detail.value;
            if ( this.groups.includes("0") ) {
                const new_groups = [];
                for ( const index in this.available_groups ) {
                    const item = this.available_groups[index];
                    if ( String(item.id) !== '0' && item.id !== 0 ) {
                        new_groups.push(String(item.id));
                    }
                }
                this.groups = new_groups;
            }
        },

        updateUsers(event) {
            this.users = event.detail.value;
            if ( this.users.includes("0") ) {
                const new_users = [];
                for ( const index in this.available_users ) {
                    const item = this.available_users[index];
                    if ( String(item.id) !== '0' && item.id !== 0 ) {
                        new_users.push(String(item.id));
                    }
                }
                this.users = new_users;
            }
        },

        async shareItem() {
            
            this.$ionic.modalController.dismiss();
            
            const spinner = await this.$ionic.loadingController.create({
                message: 'One moment while we share your annotations...'
            });

            const share_error = await this.$ionic.loadingController.create({
                message: 'Your annotations could not be shared. Please contact support for help.',
                spinner: null,
                backdropDismiss: true,
                animated: false
            });

            const share_success = await this.$ionic.loadingController.create({
                message: 'Your annotations have been shared, and users have been notified.',
                spinner: null,
                backdropDismiss: true,
                animated: false
            });
            
            spinner.present();

            const json = this.annotations.json ? this.annotations.json : JSON.stringify(this.annotations.annotations);
            const data = { annotation: this.annotations.id, json: json, user: JSON.stringify(this.users), group: JSON.stringify(this.groups), role: JSON.stringify(this.roles) }
            const headers = { 'Authorization': this.$store.getters.getAuthorizationHeaders };
            
            try {
                await axios.post(`${rootUrl}/account/annotations/share/`, data, { headers: headers });
                spinner.dismiss();
                share_success.present();
            } catch (e) {
                console.error(e);
                spinner.dismiss();
                share_error.present();   
            }
        }
    },

    mounted() {
        this.$store.dispatch('fetchBuildingProfile');
    }
};